import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import Fuse from 'fuse.js';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars';
import { Row, Col, Spin, Drawer, Space, Skeleton, Empty, Checkbox, message, Modal } from 'antd';
import AllCancelPopup from './AllCancelPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { AddUser } from '../style';
import { FetchAllLead, LeadConnectioncheck, LeadMergerUpadet, mergeLeadDelte } from '../../../Api/Services/LeadApiServices'
import { FetchAllContact, ContactConnectioncheck, mergeContactDelte, ContactMergerUpadet } from '../../../Api/Services/ContactApiService'
import { FetchAllAccount, AccountConnectioncheck, mergeAccountDelte, AccountMergerUpadet } from '../../../Api/Services/AccountApiService'
import Heading from '../../../components/heading/heading';
import { Button } from '../../../components/buttons/buttons';
import { CancelIcon, MergeIcon } from '../../../components/Icons/Icons';
import { MergeInfoCard } from '../Pages/GlobalComponents/OtherCardCmnts'

const Popup = ({ meetingOpen, setMeetingOpen, GetAll, pageIdentifier, setNaCTrigger, PryData, deletecheck }) => {
    const [displayData, setDisplayData] = useState()
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [secondaryData, setSecondaryData] = useState();
    const [selectedSecondaryIds, setSelectedSecondaryIds] = useState([]);
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [open, setOpen] = useState(false)
    // Lead code //
    const fieldMapping = {
        tags: "tags",
        first_name: "firstName",
        last_name: "lastName",
        lead_owner: "leadOwner",
        designation: "designation",
        account_name: "accountName",
        industry: "industry",
        rating: "rating",
        nom_of_employees: "nomOfEmployees",
        title: "title",
        primary_email: "primaryEmail",
        secondary_email: "secondaryEmail",
        phone: "phone",
        mobile: "mobile",
        lead_source_id: "leadSourceId",
        lead_status_id: "leadStatusId",
        email_opt_out: "emailOptOut",
        fax: "fax",
        description: "description",
        lead_profile: "leadProfile",
        lead_files: "leadFiles",
        // city: "city",
        // street: "street",
        // country: "country",
        // postcode: "postcode",
        // state: "state",
        annual_revenue: "annualRevenue",
        seniority_level_id: "seniorityLevelId"
    };
    function getDateTime(record) {
        const date = record.modified_at || "01-01-1970";
        const time = record.modified_time || "00:00";
        return new Date(`${date} ${time}`);
    }
    function buildSmartMergedLeadData({ primaryRecord, secondaryRecord, fieldMapping }) {
        const updatedFields = {};
        const usedRecordIds = new Set();
        const allRecordIds = new Set();
        secondaryRecord.forEach(sec => {
            if (sec?.leads_id) {
                allRecordIds.add(sec.leads_id);
            }
        });
        Object.entries(fieldMapping).forEach(([camelKey, snakeKey]) => {
            const primaryValue = primaryRecord[snakeKey];

            const isPrimaryMissing =
                primaryValue === null || primaryValue === undefined || primaryValue === "" ||
                (Array.isArray(primaryValue) && primaryValue.length === 0);

            if (isPrimaryMissing) {
                const candidates = secondaryRecord.filter(sec => {
                    const val = sec[snakeKey];
                    return val !== null && val !== undefined && val !== "";
                });
                if (candidates.length > 0) {
                    candidates.sort((a, b) => getDateTime(b) - getDateTime(a));
                    const bestRecord = candidates[0];
                    const bestValue = bestRecord[snakeKey];
                    updatedFields[camelKey] = bestValue;
                    if (!usedRecordIds.has(bestRecord.leads_id)) {
                        usedRecordIds.add(bestRecord.leads_id);
                    }
                }
            }
        });

        return {
            updatedFields,
            usedRecordIds: Array.from(usedRecordIds),
            allRecordIds: Array.from(allRecordIds)
        };
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setNaCTrigger("CallBack")
        setSecondaryData();
        setSelectedSecondaryIds([]);
        setErrorData([])
        setIsModalVisible(false)
        setOpen(false)
        setDisplayData()
        setMeetingOpen(false)
        setIsButtonDisabled(false)
        GetAll()
    }
    const handleClose = (closeType) => {
        if (closeType !== "Close" && selectedSecondaryIds.length > 0) {
            setCancelConfirmOpen(true)
        }
        else {
            setNaCTrigger("CallBack")
            setSecondaryData();
            setSelectedSecondaryIds([]);
            setErrorData([])
            setIsModalVisible(false)
            setOpen(false)
            setDisplayData()
            setMeetingOpen(false)
            setIsButtonDisabled(false)
            GetAll()
        }
    }
    const handleClose1 = () => {
        setNaCTrigger("CallBack")
        setSecondaryData();
        setSelectedSecondaryIds([]);
        setErrorData([])
        setIsModalVisible(false)
        setOpen(false)
        setDisplayData()
        setMeetingOpen(false)
        setIsButtonDisabled(false)
        GetAll()
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup1",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    // function findSimilarLeads(primaryData, secondaryLeads, threshold = 0.3) {
    //     if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) return [];
    //     const fuse = new Fuse(secondaryLeads, {
    //         // keys: ['first_name', 'last_name', 'primary_email', 'phone'],
    //         keys: ['first_name', 'last_name'],
    //         threshold,
    //         ignoreLocation: true,
    //         includeScore: true,
    //     });
    //     const terms = [
    //         primaryData.first_name,
    //         primaryData.last_name,
    //     ].filter(Boolean);

    //     const allResults = terms.flatMap(term => fuse.search(term));
    //     const uniqueById = new Map(allResults.map(r => [r.item.leads_id, r.item]));

    //     return Array.from(uniqueById.values());
    // }
    function findSimilarLeads(primaryData, secondaryLeads, threshold = 0.3) {
        if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) {
            return [];
        }
        const normalize = (value) => (value || '').trim().toLowerCase();
        const digitsOnly = (value) => (value || '').replace(/\D/g, '');
        const emailDomain = (email) => {
            const domain = normalize(email).split('@')[1];
            return domain || null;
        };

        // FIX: robust self-exclusion, handles missing/mismatched leads_id types
        const candidates = secondaryLeads.filter((l) => {
            if (l === primaryData) return false;
            if (primaryData.leads_id != null && l.leads_id != null) {
                return String(l.leads_id) !== String(primaryData.leads_id);
            }
            return true;
        });

        const getEmails = (lead) =>
            [lead.primary_email, lead.secondary_email].filter(Boolean).map(normalize);
        const getPhones = (lead) =>
            [lead.phone].filter(Boolean).map(digitsOnly);
        const getDomains = (lead) =>
            getEmails(lead).map(emailDomain).filter(Boolean);
        const primaryEmails = getEmails(primaryData);
        const primaryPhones = getPhones(primaryData);
        const primaryDomains = getDomains(primaryData);
        const primaryAccountName = normalize(primaryData.account_name);

        const nameFuse = new Fuse(candidates, {
            keys: ['first_name', 'last_name'],
            threshold,
            ignoreLocation: true,
            includeScore: true,
        });
        const nameResults = (primaryData.first_name && primaryData.last_name)
            ? nameFuse.search({
                $and: [
                    { first_name: primaryData.first_name },
                    { last_name: primaryData.last_name },
                ],
            })
            : [];
        // FIX: keyed by object reference, not candidate.leads_id (which may be missing/duplicated)
        const nameScoreById = new Map(nameResults.map(r => [r.item, r.score]));

        const accountFuse = new Fuse(candidates, {
            keys: ['account_name'],
            threshold,
            ignoreLocation: true,
            includeScore: true,
        });
        const accountResults = primaryData.account_name
            ? accountFuse.search(primaryData.account_name)
            : [];
        const accountScoreById = new Map(accountResults.map(r => [r.item, r.score]));

        function scoreMatch(candidate) {
            let score = 0;
            const reasons = [];
            const candidateEmails = getEmails(candidate);
            const candidatePhones = getPhones(candidate);
            const candidateDomains = getDomains(candidate);

            const hasEmailMatch = primaryEmails.some(e => candidateEmails.includes(e));
            if (hasEmailMatch) {
                score += 50;
                reasons.push('email_match');
            }
            if (primaryPhones.some(p => candidatePhones.includes(p))) {
                score += 40;
                reasons.push('phone_match');
            }
            // FIX: don't double-count domain_match when email_match already fired
            if (!hasEmailMatch && primaryDomains.some(d => candidateDomains.includes(d))) {
                score += 15;
                reasons.push('domain_match');
            }
            if (primaryAccountName && primaryAccountName === normalize(candidate.account_name)) {
                score += 10;
                reasons.push('account_name_exact_match');
            }
            const nameScore = nameScoreById.get(candidate);
            if (nameScore !== undefined) {
                score += (1 - nameScore) * 20;
                reasons.push('name_fuzzy_match');
            }
            const accountScore = accountScoreById.get(candidate);
            if (accountScore !== undefined && !reasons.includes('account_name_exact_match')) {
                score += (1 - accountScore) * 10;
                reasons.push('account_name_fuzzy_match');
            }
            return { score, reasons };
        }

        return candidates
            .map((candidate) => {
                const { score, reasons } = scoreMatch(candidate);
                return { ...candidate, matchScore: score, matchReasons: reasons };
            })
            .filter((lead) => lead.matchScore > 0)
            .sort((a, b) => b.matchScore - a.matchScore);
    }
    async function getAllLeads(PrimaryData) {
        try {
            const FetchLeadData = await FetchAllLead()
            const arrayofData = FetchLeadData?.items?.filter(item =>
                item.leads_id !== PrimaryData.leads_id &&
                (
                    item.sharingPermission === undefined ||
                    item.sharingPermission.sharePermission?.includes("Delete")
                )
            );
            const similarLeads = findSimilarLeads(PrimaryData, arrayofData);
            setSecondaryData(similarLeads)
        } catch (error) {
            setSecondaryData([])
            message.error(error);
        }
    }
    const handleCheckboxChange = (checked, record) => {
        setSelectedSecondaryIds(prev => {
            if (checked) {
                return [...prev, record];
            }
            return prev.filter(id => id.leads_id !== record.leads_id);
        });
    };
    // Contact code //
    const fieldContactMapping = {
        tags: "tags",
        seniorityLevelId: "seniority_level_id",
        firstName: "first_name",
        lastName: "last_name",
        leadOwner: "lead_owner",
        accountId: "account_id",
        title: "title",
        reportingTo: "reporting_to",
        assitantName: "assitant_name",
        department: "department",
        email: "email",
        phone: "phone",
        fax: "fax",
        designation: "designation",
        mobile: "mobile",
        contactSourceId: "contact_source_id",
        contactFiles: "contact_files",
        contactProfile: "contact_profile",
        assitantContactNumber: "assitant_contact_number",
        emailOtpOut: "email_otp_out",
        description: "description",
        // city: "city",
        // street: "street",
        // country: "country",
        // postcode: "postcode",
        // state: "state"
    }
    function getDatecontactTime(record) {
        const date = record.modified_at || "01-01-1970";
        const time = record.modified_time || "00:00";
        return new Date(`${date} ${time}`);
    }
    function buildSmartMergedContactData({ primaryRecord, secondaryRecord, fieldContactMapping }) {
        const updatedFields = {};
        const usedRecordIds = new Set();
        const allRecordIds = new Set();
        secondaryRecord.forEach(sec => {
            if (sec?.contacts_id) {
                allRecordIds.add(sec.contacts_id);
            }
        });
        Object.entries(fieldContactMapping).forEach(([camelKey, snakeKey]) => {
            const primaryValue = primaryRecord[snakeKey];

            const isPrimaryMissing =
                primaryValue === null || primaryValue === undefined || primaryValue === "" ||
                (Array.isArray(primaryValue) && primaryValue.length === 0);

            if (isPrimaryMissing) {
                const candidates = secondaryRecord.filter(sec => {
                    const val = sec[snakeKey];
                    return val !== null && val !== undefined && val !== "";
                });
                if (candidates.length > 0) {
                    candidates.sort((a, b) => getDatecontactTime(b) - getDatecontactTime(a));
                    const bestRecord = candidates[0];
                    const bestValue = bestRecord[snakeKey];
                    updatedFields[camelKey] = bestValue;
                    if (!usedRecordIds.has(bestRecord.contacts_id)) {
                        usedRecordIds.add(bestRecord.contacts_id);
                    }
                }
            }
        });

        return {
            updatedFields,
            usedRecordIds: Array.from(usedRecordIds),
            allRecordIds: Array.from(allRecordIds)
        };
    }
    // function findSimilarContct(primaryData, secondaryLeads, threshold = 0.3) {
    //     if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) return [];
    //     const fuse = new Fuse(secondaryLeads, {
    //         // keys: ['first_name', 'last_name', 'primary_email', 'phone'],
    //         keys: ['first_name', 'last_name'],
    //         threshold,
    //         ignoreLocation: true,
    //         includeScore: true,
    //     });
    //     const terms = [
    //         primaryData.first_name,
    //         primaryData.last_name,
    //     ].filter(Boolean);

    //     const allResults = terms.flatMap(term => fuse.search(term));
    //     const uniqueById = new Map(allResults.map(r => [r.item.contacts_id, r.item]));

    //     return Array.from(uniqueById.values());
    // }
    function findSimilarContct(primaryData, secondaryLeads, threshold = 0.3) {
        if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) {
            return [];
        }
        const normalize = (value) => (value || '').trim().toLowerCase();
        const digitsOnly = (value) => (value || '').replace(/\D/g, '');
        const candidates = secondaryLeads.filter((l) => {
            if (l === primaryData) return false;
            if (primaryData.contacts_id != null && l.contacts_id != null) {
                return String(l.contacts_id) !== String(primaryData.contacts_id);
            }
            return true;
        });
        const getEmails = (contact) => [contact.email].filter(Boolean).map(normalize);
        const getPhones = (contact) => [contact.phone].filter(Boolean).map(digitsOnly);
        const primaryEmails = getEmails(primaryData);
        const primaryPhones = getPhones(primaryData);
        const nameFuse = new Fuse(candidates, {
            keys: ['first_name', 'last_name'],
            threshold,
            ignoreLocation: true,
            includeScore: true,
        });
        const nameResults = (primaryData.first_name && primaryData.last_name)
            ? nameFuse.search({
                $and: [
                    { first_name: primaryData.first_name },
                    { last_name: primaryData.last_name },
                ],
            })
            : [];
        const nameScoreById = new Map(nameResults.map(r => [r.item, r.score]));
        function scoreMatch(candidate) {
            let score = 0;
            const reasons = [];
            const candidateEmails = getEmails(candidate);
            const candidatePhones = getPhones(candidate);
            const hasEmailMatch = primaryEmails.some(e => candidateEmails.includes(e));
            if (hasEmailMatch) {
                score += 50;
                reasons.push('email_match');
            }
            if (primaryPhones.some(p => candidatePhones.includes(p))) {
                score += 40;
                reasons.push('phone_match');
            }
            const nameScore = nameScoreById.get(candidate);
            if (nameScore !== undefined) {
                score += (1 - nameScore) * 20;
                reasons.push('name_fuzzy_match');
            }
            return { score, reasons };
        }
        return candidates
            .map((candidate) => {
                const { score, reasons } = scoreMatch(candidate);
                return { ...candidate, matchScore: score, matchReasons: reasons };
            })
            .filter((contact) => contact.matchScore > 0)
            .sort((a, b) => b.matchScore - a.matchScore);
    }
    async function getAllContcts(PrimaryData) {
        try {
            const FetchLeadData = await FetchAllContact()
            const arrayofData = FetchLeadData?.items?.filter(item =>
                item.contacts_id !== PrimaryData.contacts_id &&
                (
                    item.sharingPermission === undefined ||
                    item.sharingPermission.sharePermission?.includes("Delete")
                )
            );
            const similarLeads = findSimilarContct(PrimaryData, arrayofData);
            setSecondaryData(similarLeads)
        } catch (error) {
            setSecondaryData([])
            message.error(error);
        }
    }
    const handleContactCheckboxChange = (checked, record) => {
        setSelectedSecondaryIds(prev => {
            if (checked) {
                return [...prev, record];
            }
            return prev.filter(id => id.contacts_id !== record.contacts_id);
        });
    };
    // Account code //
    const fieldAccountMapping = {
        tags: "tags",
        accountnumber: "account_number",
        companyId: "company_id",
        accountName: "account_name",
        parentOrganization: "parent_organization",
        website: "website",
        accountType: "account_type",
        customerStatus: "customer_status",
        accountProfile: "account_profile",
        industry: "industry",
        ownership: "ownership",
        nomOfEmployees: "nom_of_employees",
        annualRevenue: "annual_revenue",
        accountFiles: "account_files",
        rating: "rating",
        description: "description",
        qualified: "qualified",
        accountOwner: "account_owner",
        // country: "country",
        // state: "state",
        // city: "city",
        // street: "street",
        // postcode: "postcode"
    }
    function getDateAccountTime(record) {
        const date = record.modified_at || "01-01-1970";
        const time = record.modified_time || "00:00";
        return new Date(`${date} ${time}`);
    }
    function buildSmartMergedAccountData({ primaryRecord, secondaryRecord, fieldAccountMapping }) {
        const updatedFields = {};
        const usedRecordIds = new Set();
        const allRecordIds = new Set();
        secondaryRecord.forEach(sec => {
            if (sec?.account_id) {
                allRecordIds.add(sec.account_id);
            }
        });
        Object.entries(fieldAccountMapping).forEach(([camelKey, snakeKey]) => {
            const primaryValue = primaryRecord[snakeKey];

            const isPrimaryMissing =
                primaryValue === null || primaryValue === undefined || primaryValue === "" ||
                (Array.isArray(primaryValue) && primaryValue.length === 0);

            if (isPrimaryMissing) {
                const candidates = secondaryRecord.filter(sec => {
                    const val = sec[snakeKey];
                    return val !== null && val !== undefined && val !== "";
                });
                if (candidates.length > 0) {
                    candidates.sort((a, b) => getDateAccountTime(b) - getDateAccountTime(a));
                    const bestRecord = candidates[0];
                    const bestValue = bestRecord[snakeKey];
                    updatedFields[camelKey] = bestValue;
                    if (!usedRecordIds.has(bestRecord.account_id)) {
                        usedRecordIds.add(bestRecord.account_id);
                    }
                }
            }
        });

        return {
            updatedFields,
            usedRecordIds: Array.from(usedRecordIds),
            allRecordIds: Array.from(allRecordIds)
        };
    }
    // function findSimilarAccount(primaryData, secondaryLeads, threshold = 0.3) {
    //     if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) return [];
    //     const fuse = new Fuse(secondaryLeads, {
    //         // keys: ['first_name', 'last_name', 'primary_email', 'phone'],
    //         keys: ['account_name', 'website'],
    //         threshold,
    //         ignoreLocation: true,
    //         includeScore: true,
    //     });
    //     const terms = [
    //         primaryData.account_name,
    //         primaryData.website
    //     ].filter(Boolean);

    //     const allResults = terms.flatMap(term => fuse.search(term));
    //     const uniqueById = new Map(allResults.map(r => [r.item.account_id, r.item]));

    //     return Array.from(uniqueById.values());
    // }
    function findSimilarAccount(primaryData, secondaryLeads, threshold = 0.3) {
        if (!primaryData || !secondaryLeads || !Array.isArray(secondaryLeads)) {
            return [];
        }
        const normalize = (value) => (value || '').trim().toLowerCase();
        const candidates = secondaryLeads.filter((l) => {
            if (l === primaryData) return false;
            if (primaryData.account_id != null && l.account_id != null) {
                return String(l.account_id) !== String(primaryData.account_id);
            }
            return true;
        });
        const primaryCountry = normalize(primaryData.country);
        const accountFuse = new Fuse(candidates, {
            keys: ['account_name'],
            threshold,
            ignoreLocation: true,
            includeScore: true,
        });
        const accountResults = primaryData.account_name
            ? accountFuse.search(primaryData.account_name)
            : [];
        const accountScoreById = new Map(accountResults.map(r => [r.item, r.score]));
        function scoreMatch(candidate) {
            let score = 0;
            const reasons = [];
            const accountScore = accountScoreById.get(candidate);
            const hasAccountNameMatch = accountScore !== undefined;
            if (hasAccountNameMatch) {
                score += (1 - accountScore) * 70;
                reasons.push('account_name_fuzzy_match');
            }
            const candidateCountry = normalize(candidate.country);
            if (hasAccountNameMatch && primaryCountry && primaryCountry === candidateCountry) {
                score += 30;
                reasons.push('country_match');
            }
            return { score, reasons };
        }
        return candidates
            .map((candidate) => {
                const { score, reasons } = scoreMatch(candidate);
                return { ...candidate, matchScore: score, matchReasons: reasons };
            })
            .filter((account) => account.matchScore > 0)
            .sort((a, b) => b.matchScore - a.matchScore);
    }
    async function getAllAccount(PrimaryData) {
        try {
            const FetchLeadData = await FetchAllAccount()
            const arrayofData = FetchLeadData?.filter(item =>
                (item.account_id !== PrimaryData.account_id &&
                    item.account_type_name === PrimaryData.account_type_name) &&
                (
                    item.sharingPermission === undefined ||
                    item.sharingPermission.sharePermission?.includes("Delete")
                )
            );
            const similarLeads = findSimilarAccount(PrimaryData, arrayofData);
            setSecondaryData(similarLeads)
        } catch (error) {
            setSecondaryData([])
            message.error(error);
        }
    }
    const handleCheckboxAccountChange = (checked, record) => {
        setSelectedSecondaryIds(prev => {
            if (checked) {
                return [...prev, record];
            }
            return prev.filter(id => id.account_id !== record.account_id);
        });
    };
    const onMergeclick = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (pageIdentifier === "Leads") {
            setOpen(false)
            setIsButtonDisabled(true)
            let hideMessage;
            const { updatedFields, allRecordIds } = buildSmartMergedLeadData({
                primaryRecord: displayData,
                secondaryRecord: selectedSecondaryIds,
                fieldMapping,
            })
            const formData = {
                leadIds: allRecordIds,
            }
            if (allRecordIds.length > 0) {
                try {
                    hideMessage = message.loading("loading...", 0);
                    const response = await LeadConnectioncheck(formData)
                    if (response.status === 201) {
                        if (Array.isArray(response.data) && response.data.length > 0) {
                            setErrorData(response.data);
                            setIsModalVisible(true);
                            hideMessage();
                            setIsButtonDisabled(false)
                            loadingRef.current = false;
                            setDelteClick(false)
                        } else {
                            try {
                                const response = await LeadMergerUpadet(updatedFields, displayData.leads_id)
                                if (response.status === 200) {
                                    // message.success(response?.data)
                                    await mergeLeadDelte(formData)
                                    hideMessage();
                                    handleClose("Close")
                                    successMessage("Merge Successful",
                                        <>
                                            <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.first_name} {displayData.last_name}</strong></div>
                                            <div style={{ marginTop: 10 }}>
                                                <span style={{ marginRight: 5 }}>Deleted Lead(s):</span>
                                                {selectedSecondaryIds?.map((record, index) => (
                                                    <span key={index}>
                                                        <strong>{record.first_name} {record.last_name}</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                                    </span>
                                                ))}
                                            </div>
                                        </>)
                                }
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            catch (error) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                hideMessage();
                                setIsButtonDisabled(false)
                                message.error(error)
                            }
                        }
                    }
                } catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    hideMessage();
                    setIsButtonDisabled(false)
                    message.error(error)
                }
            }
            else {
                await mergeLeadDelte(formData)
                setIsButtonDisabled(false)
                handleClose("Close")
                successMessage("Merge Successful",
                    <>
                        <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.first_name} {displayData.last_name}</strong></div>
                        <div style={{ marginTop: 10 }}>
                            <span style={{ marginRight: 5 }}>Deleted Lead(s):</span>
                            {selectedSecondaryIds?.map((record, index) => (
                                <span key={index}>
                                    <strong>{record.first_name} {record.last_name}</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                </span>
                            ))}
                        </div>
                    </>)
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
        if (pageIdentifier === "Contacts") {
            setOpen(false)
            setIsButtonDisabled(true)
            let hideMessage;
            const { updatedFields, allRecordIds } = buildSmartMergedContactData({
                primaryRecord: displayData,
                secondaryRecord: selectedSecondaryIds,
                fieldContactMapping,
            })
            const formData = {
                contactIds: allRecordIds,
            }
            if (allRecordIds.length > 0) {
                try {
                    hideMessage = message.loading("loading...", 0);
                    const response = await ContactConnectioncheck(formData)
                    if (response.status === 201) {
                        if (Array.isArray(response.data) && response.data.length > 0) {
                            setErrorData(response.data);
                            setIsModalVisible(true);
                            hideMessage();
                            setIsButtonDisabled(false)
                            loadingRef.current = false;
                            setDelteClick(false)
                        } else {
                            try {
                                const response = await ContactMergerUpadet(updatedFields, displayData.contacts_id)
                                if (response.status === 200) {
                                    // message.success(response?.data)
                                    await mergeContactDelte(formData)
                                    hideMessage();
                                    handleClose("Close")
                                    successMessage("Merge Successful",
                                        <>
                                            <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.first_name} {displayData.last_name}</strong></div>
                                            <div style={{ marginTop: 10 }}>
                                                <span style={{ marginRight: 5 }}>Deleted Contact(s):</span>
                                                {selectedSecondaryIds?.map((record, index) => (
                                                    <span key={index}>
                                                        <strong>{record.first_name} {record.last_name}</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                                    </span>
                                                ))}
                                            </div>
                                        </>)
                                }
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            catch (error) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                hideMessage();
                                setIsButtonDisabled(false)
                                message.error(error)
                            }
                        }
                    }
                } catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    hideMessage();
                    setIsButtonDisabled(false)
                    message.error(error)
                }
            }
            else {
                await mergeContactDelte(formData)
                setIsButtonDisabled(false)
                handleClose("Close")
                successMessage("Merge Successful",
                    <>
                        <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.first_name} {displayData.last_name}</strong></div>
                        <div style={{ marginTop: 10 }}>
                            <span style={{ marginRight: 5 }}>Deleted Contact(s):</span>
                            {selectedSecondaryIds?.map((record, index) => (
                                <span key={index}>
                                    <strong>{record.first_name} {record.last_name}</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                </span>
                            ))}
                        </div>
                    </>)
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
        if (pageIdentifier === "Accounts") {
            setOpen(false)
            setIsButtonDisabled(true)
            let hideMessage;
            const { updatedFields, allRecordIds } = buildSmartMergedAccountData({
                primaryRecord: displayData,
                secondaryRecord: selectedSecondaryIds,
                fieldAccountMapping,
            })
            const formData = {
                accountIds: allRecordIds,
            }
            if (allRecordIds.length > 0) {
                try {
                    hideMessage = message.loading("loading...", 0);
                    const response = await AccountConnectioncheck(formData)
                    if (response.status === 201) {
                        if (Array.isArray(response.data) && response.data.length > 0) {
                            setErrorData(response.data);
                            setIsModalVisible(true);
                            hideMessage();
                            setIsButtonDisabled(false)
                            loadingRef.current = false;
                            setDelteClick(false)
                        } else {
                            try {
                                const response = await AccountMergerUpadet(updatedFields, displayData.account_id)
                                if (response.status === 200) {
                                    // message.success(response?.data)
                                    await mergeAccountDelte(formData)
                                    hideMessage();
                                    handleClose("Close")
                                    successMessage("Merge Successful",
                                        <>
                                            <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.account_name}</strong></div>
                                            <div style={{ marginTop: 10 }}>
                                                <span style={{ marginRight: 5 }}>Deleted Account(s):</span>
                                                {selectedSecondaryIds?.map((record, index) => (
                                                    <span key={index}>
                                                        <strong>{record.account_name} ({record.account_number})</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                                    </span>
                                                ))}
                                            </div>
                                        </>)
                                }
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            catch (error) {
                                loadingRef.current = false;
                                setDelteClick(false)
                                hideMessage();
                                setIsButtonDisabled(false)
                                message.error(error)
                            }
                        }
                    }
                } catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    hideMessage();
                    setIsButtonDisabled(false)
                    message.error(error)
                }
            }
            else {
                await mergeAccountDelte(formData)
                setIsButtonDisabled(false)
                handleClose("Close")
                successMessage("Merge Successful",
                    <>
                        <div>The following records were deleted after being successfully merged with the primary record <strong>{displayData.account_name}</strong></div>
                        <div style={{ marginTop: 10 }}>
                            <span style={{ marginRight: 5 }}>Deleted Account(s):</span>
                            {selectedSecondaryIds?.map((record, index) => (
                                <span key={index}>
                                    <strong>{record.account_name} ({record.account_number})</strong>{index !== selectedSecondaryIds.length - 1 && ", "}
                                </span>
                            ))}
                        </div>
                    </>)
                loadingRef.current = false;
                setDelteClick(false)
            }
        }
    }
    const getRefreshtheTable = () => {
        handleClose1()
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    useEffect(() => {
        if (meetingOpen && pageIdentifier) {
            setDisplayData(PryData)
            if (pageIdentifier === "Leads") {
                getAllLeads(PryData)
            }
            if (pageIdentifier === "Contacts") {
                getAllContcts(PryData)
            }
            if (pageIdentifier === "Accounts") {
                getAllAccount(PryData)
            }
        }
    }, [meetingOpen, pageIdentifier])
    const onckickofMerge = () => {
        if (deletecheck) {
            message.info("Delete permission is not granted for your system role");
        }
        else {
            setOpen(true)
        }
    }
    return (
        <>
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                closable={false}
                placement="right"
                title="Merge Duplicate"
                open={meetingOpen}
                width="40%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => handleClose()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    handleClose()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space >
                }
                footer={
                    <div className="form_action_button">
                        <Button size="small" disabled={isButtonDisabled || selectedSecondaryIds.length === 0} className="button_colors" onClick={() => onckickofMerge()}>
                            <MergeIcon />Merge Records
                        </Button>
                    </div>}
            >
                {displayData ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <div className="add-product-block">
                                <div style={{ margin: 40 }}>
                                    <Row gutter={15}>
                                        <Col xs={24}>
                                            <div className="add-product-content">
                                                <Heading as="h5">Primary Record</Heading>
                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                    <Col span={24} style={{ marginBottom: 20 }}>
                                                        {pageIdentifier === "Leads" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <Checkbox disabled checked /> <MergeInfoCard Pagetype={pageIdentifier} key={displayData.leads_id} item={{ id: displayData.leads_id, first_name: displayData.first_name, last_name: displayData.last_name }} />
                                                        </div> : ""}
                                                        {pageIdentifier === "Contacts" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <Checkbox disabled checked /> <MergeInfoCard Pagetype={pageIdentifier} key={displayData.contacts_id} item={{ id: displayData.contacts_id, first_name: displayData.first_name, last_name: displayData.last_name }} />
                                                        </div> : ""}
                                                        {pageIdentifier === "Accounts" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                            <Checkbox disabled checked /> <MergeInfoCard Pagetype={pageIdentifier} key={displayData.account_id} item={{ id: displayData.account_id, account_name: displayData.account_name }} />
                                                        </div> : ""}
                                                    </Col>
                                                </Row>
                                                <Heading as="h5">Similar Records</Heading>
                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                    <Col span={24} style={{ marginBottom: 20 }}>
                                                        {!secondaryData ?
                                                            <Skeleton active paragraph={{ rows: 10, width: "100%" }} /> :
                                                            secondaryData.length === 0 ? <Empty /> :
                                                                secondaryData.map((items, index) => {
                                                                    return (
                                                                        <div key={index} style={{ marginBottom: "10px" }}>
                                                                            {pageIdentifier === "Leads" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                                <Checkbox checked={selectedSecondaryIds.some(r => r.leads_id === items.leads_id)}
                                                                                    onChange={(e) => handleCheckboxChange(e.target.checked, items)} /> <MergeInfoCard Pagetype={pageIdentifier} key={items.leads_id} item={{ id: items.leads_id, first_name: items.first_name, last_name: items.last_name }} /> </div> : ""}
                                                                            {pageIdentifier === "Contacts" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                                <Checkbox checked={selectedSecondaryIds.some(r => r.contacts_id === items.contacts_id)}
                                                                                    onChange={(e) => handleContactCheckboxChange(e.target.checked, items)} /> <MergeInfoCard Pagetype={pageIdentifier} key={items.contacts_id} item={{ id: items.contacts_id, first_name: items.first_name, last_name: items.last_name }} /> </div> : ""}
                                                                            {pageIdentifier === "Accounts" ? <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                                <Checkbox checked={selectedSecondaryIds.some(r => r.account_id === items.account_id)}
                                                                                    onChange={(e) => handleCheckboxAccountChange(e.target.checked, items)} /> <MergeInfoCard Pagetype={pageIdentifier} key={items.account_id} item={{ id: items.account_id, account_name: items.account_name }} /> </div> : ""}
                                                                        </div>)
                                                                })}
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div></div>
                    </AddUser >
                </Scrollbars>
                    :
                    <div className="spin">
                        <Spin />
                    </div>
                }
            </Drawer>
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="DetailsError" type={pageIdentifier} getCallBack={getRefreshtheTable} DeletePermission="Yes" onMergeclick={onMergeclick} />}
            {open && <Modal
                title="Merge Confirmation"
                open={open}
                onCancel={() => setOpen(false)}
                // width={700}
                maskClosable={false}
                footer={[
                    <div>
                        <Button htmlType="submit" size="small" onClick={onMergeclick} className="button_colors" loading={deleteClick} disabled={deleteClick}>
                            {!deleteClick && <MergeIcon />} Merge
                        </Button>
                    </div>
                ]}
            >
                <div style={{ padding: "0px 20px" }}><p>Are you sure you want to merge the selected record(s)?</p></div>
            </Modal>}
        </>
    );
};

Popup.propTypes = {
    meetingOpen: PropTypes.bool.isRequired,
    setMeetingOpen: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    pageIdentifier: PropTypes.string.isRequired,
    PryData: PropTypes.object.isRequired,
    deletecheck: PropTypes.bool.isRequired,
};

export default Popup;